var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackendTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9851 1.71257C10.6698 2.25859 9.97163 2.44567 9.42561 2.13043C8.8796 1.81518 8.69252 1.117 9.00776 0.570985C9.323 0.0249715 10.0212 -0.162107 10.5672 0.153135C11.1132 0.468376 11.3003 1.16656 10.9851 1.71257ZM3.14692 13.0037C5.87699 14.5799 9.36791 13.6445 10.9441 10.9145C12.5203 8.18439 11.5849 4.69347 8.85487 3.11726C6.1248 1.54105 2.63387 2.47644 1.05767 5.20651C-0.518541 7.93658 0.41685 11.4275 3.14692 13.0037ZM7.68081 5.07424C7.88599 4.84626 7.86751 4.49512 7.63953 4.28993C7.41155 4.08475 7.0604 4.10323 6.85522 4.33121L4.22377 7.25504C4.07706 7.41806 4.04002 7.65215 4.12925 7.8525C4.21847 8.05285 4.41725 8.18192 4.63657 8.18192H6.02103L3.56591 10.9098C3.36073 11.1378 3.37921 11.489 3.60719 11.6941C3.83517 11.8993 4.18632 11.8808 4.3915 11.6529L7.68081 7.99807C7.82752 7.83506 7.86456 7.60096 7.77533 7.40062C7.68611 7.20027 7.48733 7.0712 7.26801 7.0712H5.88355L7.68081 5.07424ZM1.43448 15.9722C1.9805 16.2874 2.67868 16.1004 2.99392 15.5543C3.30917 15.0083 3.12209 14.3101 2.57607 13.9949C2.03006 13.6797 1.33188 13.8667 1.01663 14.4128C0.701393 14.9588 0.888471 15.657 1.43448 15.9722Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackendTrigger);
export default __webpack_public_path__ + "static/media/backend-trigger.21f7aaf66ace3d5d956146316152f80d.svg";
export { ForwardRef as ReactComponent };